import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, onMounted, onUnmounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SeeMoreButton',
  setup(__props) {

const isAtTop = ref(true)

function checkScroll() {
  isAtTop.value = window.scrollY === 0
  console.log(isAtTop.value)
}

function handleScroll() {
  window.scrollBy({
    top: window.innerHeight,
    behavior: 'smooth'
  });
}

onMounted(() => {
  window.addEventListener('scroll', checkScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', checkScroll)
})

return (_ctx: any,_cache: any) => {
  return (isAtTop.value)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        onClick: handleScroll
      }, " MEER LEZEN "))
    : _createCommentVNode("", true)
}
}

})